import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useDidMount } from "../../coraWebComponents/utils/hooks";
import { useNavigate } from "react-router";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./Ulohy.scss";

// proptypes
import ulohaPropTypes from "../../propTypes/ulohaPropTypes";

// components
import UlohyDetail from "./UlohyDetail";
import Grid from '../../coraWebComponents/dataGrid/DataGrid';
import flags from '../../coraWebComponents/dataGrid/flags';
import Tab from "../../coraWebComponents/Tab";
import Tabs from "../../coraWebComponents/TabsWrapper";
// coraWebComponents

import Button from "../../coraWebComponents/buttons/Button";
import { showMsg } from '../../coraWebComponents/utils/logger';

// Constants
import Routes from "../../constants/Routes";
import * as storage from '../../coraWebComponents/utils/storage';

// actions
import * as appHeaderActions from "../../actions/appHeaderActions";
import * as ulohyActions from "../../actions/ulohyActions";
import * as ziadostActions from "../../actions/ziadostActions";

import * as ziadostUtils from "../../utils/ziadostUtils";
import _ from "lodash";

const MojeUlohy = (props) => {
  const { isLoading, total, listUloha } = props;

  const [selected, setSelected] = useState([]);
  const filter = useRef({ filters: [] });
  const sort = useRef([]);
  const page = useRef({ skip: 0, take: 10 });
  const setFilter = (newFilter) => { filter.current = newFilter };
  const setSort = (newSort) => { sort.current = newSort };
  const setPage = (newPage) => { page.current = newPage };

  const [data, setData] = useState(listUloha);

  const navigate = useNavigate();

  const expandChange = useCallback((event) => {
    const id = parseInt(_.keys(event.detailExpand)[0]);

    setData(prevData =>
      prevData.map(x =>
        x.I_AG_ZIADOST === id
          ? { ...x, expanded: !x.expanded }
          : x
      )
    );
  }, []);

  useEffect(() => {
    setData(listUloha);
  }, [listUloha]);


  // GRID PROPS
  const handleChange = useCallback((filter, sort, page) => {
    setFilter(filter);
    setSort(sort);
    setPage(page);
  }, [])

  const handleOnGetList = useCallback(async () => {
    await props.getListUloha(filter.current, sort.current, page.current);

    setSelected(prevSelected =>
      props.listUloha.filter(item =>
        prevSelected.find(
          x => x.I_AG_ZIADOST === item.I_AG_ZIADOST
        )
      )
    );
  }, [props.getListUloha, props.listUloha]);

  const handleOnGet = useCallback((item) => {
    const ziadost = item?.Data ?? null;
    props.changeZiadost(ziadost);
  }, [props.changeZiadost]);


  const genSchema = () => {
    return [
      {
        field: "KOD_ZIADOSTI",
        title: "Kód",
        width: "auto",
        filterable: true,
        filter: "text",
        filterTitle: "Kód"
      },
      {
        field: "ADRESA_STAVBA",
        title: "Adresa",
        width: "auto",
        filterable: true,
        filter: "text",
        filterTitle: "Adresa"
      },
      {
        field: "ZIADATEL",
        title: "Žiadateľ",
        width: "auto",
        filterable: true,
        filter: "text",
        filterTitle: "Žiadateľ"
      },
      {
        field: "N_STAV_ZIAD",
        title: "Stav",
        width: "140px",
        filterable: true,
        filter: "text",
        filterTitle: "Stav"
      },
      {
        field: "D_POD",
        title: "Vytvorené",
        width: "auto",
        filter: "date",
        format: "{0:dd.MM.yyyy}",
        filter: "datetimeinput",
        operator: "datetimeinput",
        type: "datetimeinput",
        filterTitle: "Vytvorené"
      },
      {
        field: "N_UZ_VYBAVUJE",
        title: "Vybavuje",
        width: "auto",
        filterable: true,
        filter: "text",
        filterTitle: "Vybavuje"
      },
      {
        field: "Priorita.SKR",
        title: "Priorita",
        width: "auto",
        filter: "auto",
        filterable: true,
        filter: "text",
        filterTitle: "Priorita"
      },
      {
        field: "D_VYBAVENIA",
        title: "Vybavené",
        width: "auto",
        filter: "date",
        format: "{0:dd.MM.yyyy}",
        filterable: true,
        filter: "datetimeinput",
        operator: "datetimeinput",
        type: "datetimeinput",
        filterTitle: "Vybavené"
      },
    ];
  };
  const schema = useMemo(() => genSchema(), []);

  // BUTTON PROPS
  const handleOnBtnVyjadClick = (e) => {
    if (selected.length !== 1) {
      props.showMsg("Je potrebné označiť práve jeden záznam.");
      return;
    }

    navigate(Routes.VYTVORIT_VYJADRENIE, { state: { skipBlocker: true, from: Routes.MOJE_ULOHY } });
  };

  const handleOnBtnRezClick = async (e) => {
    const otvorene = selected.filter(item => item.I_STAV_ZIAD === 1);
    await Promise.all(otvorene.map(async (item) => {
      await ziadostUtils.vybavuje(item.I_AG_ZIADOST);
      return item;
    }));

    handleOnGetList();
  };

  const fixedFilter = useMemo(() => ({ filters: [] }), []);
  const noop = useCallback(() => { }, []);
  const emptyArray = useMemo(() => [], []);

  useDidMount(async () => {
    const {
      showAppHeader,
      changeHeaderTitle
    } = props;

    showAppHeader(false);
    changeHeaderTitle("Moje úlohy");
  })

  useEffect(() => {
    return () => {
      props.showAppHeader(false);
    }
  }, []); // eslint-disable-line

  const getActions = useCallback(() => {
    const user = storage.getUser();
    const otvorene = selected.filter(item => item.I_STAV_ZIAD === 1);
    const btnRezDisabled = otvorene.length === 0;
    const btnVyjDisabled = selected.length === 0;

    return (
      <div className="btnRezVyjadrenie">
        <Button
          primary={true}
          onClick={handleOnBtnRezClick}
          disabled={btnRezDisabled}
          label="Rezervovať"
        />
        <Button
          primary={true}
          onClick={handleOnBtnVyjadClick}
          disabled={btnVyjDisabled}
          label="Vytvoriť vyjadrenie"
        />
      </div>
    )
  }, [selected]);


  const cellRender = useCallback((tdElement, cellProps) => {
    const { field, dataItem } = cellProps;
    var tdProps = { ...tdElement.props };
    var children = tdElement.props.children;

    if (field === "N_STAV_ZIAD") {
      tdProps.className += " stav";
      const className = (dataItem["N_STAV_ZIAD"] === "Uzavreté" ? " green" :
        (dataItem["N_STAV_ZIAD"] === "Zamietnuté" ? " red" :
          (dataItem["N_STAV_ZIAD"] === "Rezervované" ? " orange" : " yellow")));
      const iconClassName = (dataItem["N_STAV_ZIAD"] === "Uzavreté" ? "k-icon k-font-icon k-i-check" :
        (dataItem["N_STAV_ZIAD"] === "Zamietnuté" ? "k-icon k-font-icon k-i-close" :
          (dataItem["N_STAV_ZIAD"] === "Rezervované" ? "k-icon k-font-icon k-i-lock" : "k-icon k-font-icon k-i-folder-open")));
      children = (<div className={className}><span>{children}</span><span className={iconClassName}></span></div>);
    }
    return React.cloneElement(tdElement, { ...tdProps }, children);
  }, []);

  const handleGridSelect = useCallback((selected) => {
    setSelected(selected);
  }, []);

  const initSort = useMemo(() => (
    [{ field: "D_POD", dir: "desc" }]
  ), []);

  const isDesktop = useMemo(() => {
    return window.matchMedia('only screen and (min-width: 768px)').matches
  }, []);

  return (
    <div className="row m-0">
      <div className="col p-0">
        <div className="grid-info-row"><div className="grid-info-row-name">Moje úlohy</div><div className="grid-info-row-filters"></div></div>
        <Tabs>
          <Tab title="Zoznam">
            <Grid
              className={(isDesktop ? "" : " mobile") + " ulohy"}
              total={total}
              data={data}
              isLoading={isLoading}
              onChange={handleChange}
              onGet={handleOnGet}
              onGetList={handleOnGetList}
              onExpandChange={expandChange}
              selected={selected}
              onSelect={handleGridSelect}
              primaryField="copy2-I_AG_ZIADOST"
              schema={schema}
              detailSchema={emptyArray}
              detail={UlohyDetail}
              cellRender={cellRender}
              toolbarActions={getActions}
              allColumns
              multiple
              printable
              cellSelect
              fixedFilter={fixedFilter}
              onChangeField={noop}
              onDelete={noop}
              onCancel={noop}
              updateSort={noop}
              initSort={initSort}
              filter={filter.current}
              sort={sort.current}
              page={page.current}
              hidden={flags.ADD | flags.COPY | flags.DELETE | flags.CANCEL | flags.PRINT | flags.RESET |
                flags.EDIT | flags.COLUMN_MENU | flags.COLUMN_SELECTED | flags.EDITALL | flags.GRID_CELL_EDIT | flags.USER_FILTER | flags.DETAIL}
              hiddenBack
              userFilterList={emptyArray}
              userFilterExtended={emptyArray}
              showMsg={props.showMsg}
            />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    listUloha: state.listUloha.data,
    isLoading: state.listUloha.isLoading,
    total: state.listUloha.total,
    ziadost: state.ziadost.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  changeZiadost: (ziadost) => dispatch(ziadostActions.changeZiadost(ziadost)),
  changeHeaderTitle: (title) =>
    dispatch(appHeaderActions.changeHeaderTitle(title)),
  getListUloha: (filter, sort, page) =>
    dispatch(ulohyActions.getListUloha(filter, sort, page)),
  showAppHeader: (show) => dispatch(appHeaderActions.showAppHeader(show)),
  showMsg: (msg, msgType = 'ok', isDialog = false, title) => dispatch(showMsg(msg, msgType, isDialog, title))
});

MojeUlohy.propTypes = {
  changeHeaderTitle: PropTypes.func,
  changeZiadost: PropTypes.func,
  getListUloha: PropTypes.func,
  listUloha: PropTypes.arrayOf(ulohaPropTypes.uloha),
  isLoading: PropTypes.bool,
  showAppHeader: PropTypes.func,
  total: PropTypes.number,
};

export default connect(mapStateToProps, mapDispatchToProps)(MojeUlohy);
